import { render, staticRenderFns } from "./Wp_order_count.vue?vue&type=template&id=14d573b6&scoped=true&"
import script from "./Wp_order_count.vue?vue&type=script&lang=js&"
export * from "./Wp_order_count.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d573b6",
  null
  
)

export default component.exports